/** "9 Oct 2026, 14:05" in the UI language; '' for an invalid timestamp. */
export function formatGeneratedAt(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
}
